var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-0",attrs:{"app":"","height":"30"}},[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('div',{staticClass:"text-center caption grey--text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }